export const POINTER = {
    top: 'top',
    left: 'left',
    right: 'right',
    bottom: 'bottom',
};
export const MIN_WIDTH = 48;
export const POINTER_POSITION = -6;
export const HORIZONTAL_DEFAULT_POINTER_POSITION = 30;
export const VERTICAL_DEFAULT_POINTER_POSITION = 7;
export const DISMISS_ICON_TITLE = 'Dismiss Tooltip';
